/**
 * @fileoverview Select styles and option lookup helpers for the Location section.
 */

import { logger } from "../../../utils/logger.js";
import { getReferencedDataOptionById } from "../../../utils/common";

const getNotSingleSelectWidth = () => {
  return "100%";
};

export const getLocationSelectStyles = () => ({
  control: (baseStyles) => ({
    ...baseStyles,
    borderRadius: "8px",
    fontSize: "14px",
    cursor: "pointer",
    borderColor: baseStyles.borderColor,
    marginBottom: "-10px",
    width: getNotSingleSelectWidth(),
  }),
  container: (baseStyles) => ({
    ...baseStyles,
  }),
  valueContainer: (baseStyles) => ({
    ...baseStyles,
  }),
  input: (baseStyles) => ({
    ...baseStyles,
  }),
  option: (baseStyles) => ({
    ...baseStyles,
    cursor: "pointer",
  }),
  indicatorSeparator: () => ({ display: "none" }),
});

export const getOptionValue = (value) => {
  if (value === null || value === undefined) {
    return null;
  }
  return value;
};

export const getSafeSelectedOption = (options, value) => {
  if (!Array.isArray(options)) {
    logger.warn("Options is not an array:", { data: options });
    return null;
  }
  return getReferencedDataOptionById(options, getOptionValue(value));
};
